(function(){
  function rng(seed){let s=seed>>>0||1;return()=>{s^=s<<13;s^=s>>>17;s^=s<<5;return((s>>>0)%100000)/100000;};}
  function makeNoise(seed){
    const r=rng(seed),N=256,p=new Float32Array(N*N);
    for(let i=0;i<p.length;i++)p[i]=r();
    const sm=t=>t*t*(3-2*t);
    const v=(x,y)=>{const xi=Math.floor(x),yi=Math.floor(y),xf=x-xi,yf=y-yi;
      const a=p[((yi&255)*N)+(xi&255)],b=p[((yi&255)*N)+((xi+1)&255)],c=p[(((yi+1)&255)*N)+(xi&255)],d=p[(((yi+1)&255)*N)+((xi+1)&255)];
      const u=sm(xf),w=sm(yf);return a+(b-a)*u+(c-a)*w+(a-b-c+d)*u*w;};
    return (x,y)=>{let t=0,amp=1,f=1,n=0;for(let o=0;o<4;o++){t+=v(x*f,y*f)*amp;n+=amp;amp*=.5;f*=2.03;}return t/n;};
  }
  function contours(ctx,w,h,opt){
    const cell=opt.cell||8,cols=Math.ceil(w/cell)+1,rows=Math.ceil(h/cell)+1,noise=makeNoise(opt.seed);
    const g=new Float32Array(cols*rows);
    for(let j=0;j<rows;j++)for(let i=0;i<cols;i++){
      let val=noise(i*cell/opt.scale,j*cell/opt.scale);
      if(opt.bias)val=opt.bias(val,i*cell/w,j*cell/h);
      g[j*cols+i]=val;
    }
    const L=opt.levels;
    for(let k=0;k<L;k++){
      const lv=opt.min+(opt.max-opt.min)*(k+.5)/L;
      ctx.beginPath();
      for(let j=0;j<rows-1;j++)for(let i=0;i<cols-1;i++){
        const a=g[j*cols+i],b=g[j*cols+i+1],c=g[(j+1)*cols+i+1],d=g[(j+1)*cols+i];
        const idx=(a>lv?8:0)|(b>lv?4:0)|(c>lv?2:0)|(d>lv?1:0);
        if(idx===0||idx===15)continue;
        const x=i*cell,y=j*cell,lerp=(p,q)=>(lv-p)/(q-p);
        const T=[x+cell*lerp(a,b),y],R=[x+cell,y+cell*lerp(b,c)],B=[x+cell*lerp(d,c),y+cell],Lf=[x,y+cell*lerp(a,d)];
        const seg=(P,Q)=>{ctx.moveTo(P[0],P[1]);ctx.lineTo(Q[0],Q[1]);};
        switch(idx){case 1:case 14:seg(Lf,B);break;case 2:case 13:seg(B,R);break;case 3:case 12:seg(Lf,R);break;
          case 4:case 11:seg(T,R);break;case 5:seg(Lf,T);seg(B,R);break;case 6:case 9:seg(T,B);break;
          case 7:case 8:seg(Lf,T);break;case 10:seg(T,R);seg(Lf,B);break;}
      }
      ctx.strokeStyle=opt.color(k/(L-1));ctx.lineWidth=opt.width(k/(L-1));ctx.stroke();
    }
  }
  const ramp=t=>{
    const s=[[248,206,43],[249,168,37],[241,129,27]];const x=t*2,i=Math.min(1,Math.floor(x)),f=x-i;
    const c=s[i].map((v,n)=>Math.round(v+(s[i+1][n]-v)*f));return c;};
  function drawHero(){
    const cv=document.getElementById('heroField');if(!cv)return;
    const r=cv.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);
    cv.width=Math.round(r.width*dpr);cv.height=Math.round(r.height*dpr);
    const ctx=cv.getContext('2d');ctx.scale(dpr,dpr);ctx.clearRect(0,0,r.width,r.height);
    contours(ctx,r.width,r.height,{seed:2026,scale:260,cell:7,levels:18,min:.3,max:.72,
      bias:(v,x)=>v+ (x-.35)*.22,
      color:t=>{const c=ramp(t);return `rgba(${c[0]},${c[1]},${c[2]},${.10+.32*t})`;},
      width:t=>t>.9?1.6:.9});
    const gr=ctx.createLinearGradient(0,0,r.width,0);
    gr.addColorStop(0,'rgba(11,10,8,.92)');gr.addColorStop(.55,'rgba(11,10,8,.55)');gr.addColorStop(1,'rgba(11,10,8,0)');
    ctx.fillStyle=gr;ctx.fillRect(0,0,r.width,r.height);
  }
  function drawCard(cv){
    const r=cv.getBoundingClientRect();if(!r.width)return;
    const dpr=Math.min(window.devicePixelRatio||1,2);cv.width=Math.round(r.width*dpr);cv.height=Math.round(r.height*dpr);
    const ctx=cv.getContext('2d');ctx.scale(dpr,dpr);const w=r.width,h=r.height,seed=+cv.dataset.seed,mode=cv.dataset.mode;
    ctx.fillStyle='#0E0D0A';ctx.fillRect(0,0,w,h);
    const fan=(cx,cy,rad)=>{
      ctx.save();ctx.beginPath();ctx.arc(cx,cy,rad,0,Math.PI*2);ctx.clip();
      contours(ctx,w,h,{seed:seed+Math.round(cx),scale:60,cell:4,levels:9,min:.3,max:.7,color:t=>{const c=ramp(t);return `rgb(${c})`;},width:()=>1.1});
      ctx.restore();
      ctx.beginPath();ctx.arc(cx,cy,rad*.36,0,Math.PI*2);ctx.fillStyle='#0E0D0A';ctx.fill();
      ctx.lineWidth=2;ctx.strokeStyle='#F8CE2B';ctx.beginPath();ctx.arc(cx,cy,rad,0,Math.PI*2);ctx.stroke();
      ctx.beginPath();ctx.arc(cx,cy,rad*.36,0,Math.PI*2);ctx.stroke();
    };
    const panel=(x,y,pw,ph,levels)=>{
      ctx.save();ctx.beginPath();ctx.roundRect?ctx.roundRect(x,y,pw,ph,6):ctx.rect(x,y,pw,ph);ctx.clip();
      ctx.fillStyle='#14120E';ctx.fillRect(x,y,pw,ph);
      contours(ctx,w,h,{seed,scale:90,cell:4,levels,min:.28,max:.72,color:t=>{const c=ramp(t);return `rgba(${c},${.55+.45*t})`;},width:t=>t>.85?1.8:1});
      ctx.restore();ctx.lineWidth=1.5;ctx.strokeStyle='rgba(243,238,226,.35)';
      ctx.beginPath();ctx.roundRect?ctx.roundRect(x,y,pw,ph,6):ctx.rect(x,y,pw,ph);ctx.stroke();
    };
    if(mode==='rings'){const rad=Math.min(w/7.4,h/3.2);[w*.2,w*.5,w*.8].forEach(cx=>fan(cx,h*.5,rad));}
    else if(mode==='panel'){panel(w*.1,h*.1,w*.5,h*.8,12);const rad=Math.min(w*.1,h*.13);[h*.24,h*.5,h*.76].forEach(cy=>fan(w*.78,cy,rad));}
    else if(mode==='full'){panel(w*.06,h*.08,w*.88,h*.84,16);const rad=Math.min(w*.07,h*.1);[w*.3,w*.5,w*.7].forEach(cx=>fan(cx,h*.28,rad));}
    else if(mode==='tower'){
      const x=w*.28,y=h*.1,cw=w*.44,ch=h*.8;
      ctx.fillStyle='#14120E';ctx.fillRect(x-6,y-6,cw+12,ch+12);
      panel(x,y,cw,ch,seed%2?10:14);
      const rad=Math.min(cw*.2,ch*.12);[y+ch*.2,y+ch*.5,y+ch*.8].forEach(cy=>fan(x+cw*.78,cy,rad));
      ctx.strokeStyle='rgba(243,238,226,.5)';ctx.lineWidth=2;ctx.strokeRect(x-6,y-6,cw+12,ch+12);
    }
    else if(mode==='snowblind'){
      const x=w*.26,y=h*.1,cw=w*.48,ch=h*.8;
      ctx.fillStyle='#14120E';ctx.fillRect(x-6,y-6,cw+12,ch+12);
      panel(x,y,cw,ch,8);
      const rad=Math.min(cw*.18,ch*.11);[y+ch*.22,y+ch*.52].forEach(cy=>fan(x+cw*.8,cy,rad));
      ctx.fillStyle='rgba(243,238,226,.16)';ctx.fillRect(x,y,cw,ch);
      ctx.fillStyle='rgba(243,238,226,.05)';for(let sy=y;sy<y+ch;sy+=3)ctx.fillRect(x,sy,cw,1);
      const fs=Math.max(9,Math.round(cw*.075));ctx.font=`600 ${fs}px "JetBrains Mono", monospace`;
      ctx.fillStyle='#F8CE2B';ctx.fillText('CPU 62°C',x+cw*.08,y+ch*.74);ctx.fillText('GPU 68°C',x+cw*.08,y+ch*.74+fs*1.4);
      ctx.fillStyle='#F1811B';ctx.fillRect(x+cw*.08,y+ch*.74+fs*2.1,cw*.5,3);ctx.fillStyle='#F8CE2B';ctx.fillRect(x+cw*.08,y+ch*.74+fs*2.1,cw*.32,3);
      ctx.strokeStyle='rgba(243,238,226,.6)';ctx.lineWidth=2;ctx.strokeRect(x-6,y-6,cw+12,ch+12);
    }
    else if(mode==='car'){
      const base=h*.7,l=w*.1,r=w*.9;
      const body=()=>{ctx.beginPath();ctx.moveTo(l,base);ctx.lineTo(l+w*.02,base-h*.14);ctx.lineTo(l+w*.28,base-h*.2);
        ctx.lineTo(l+w*.46,base-h*.38);ctx.lineTo(l+w*.62,base-h*.36);ctx.lineTo(r-w*.02,base-h*.18);ctx.lineTo(r,base);ctx.closePath();};
      ctx.save();body();ctx.clip();ctx.fillStyle='#14120E';ctx.fillRect(0,0,w,h);
      contours(ctx,w,h,{seed,scale:70,cell:4,levels:12,min:.28,max:.72,color:t=>{const c=ramp(t);return `rgba(${c},${.55+.45*t})`;},width:()=>1.1});
      ctx.restore();body();ctx.strokeStyle='#F8CE2B';ctx.lineWidth=2;ctx.stroke();
      [l+w*.18,r-w*.18].forEach(cx=>{ctx.beginPath();ctx.arc(cx,base,h*.1,0,Math.PI*2);ctx.fillStyle='#0E0D0A';ctx.fill();ctx.strokeStyle='#F1811B';ctx.stroke();});
      ctx.strokeStyle='rgba(243,238,226,.25)';ctx.beginPath();ctx.moveTo(w*.04,base+h*.1);ctx.lineTo(w*.96,base+h*.1);ctx.stroke();
    }
    else {
      panel(w*.08,h*.08,w*.5,h*.62,12);
      const bx=w*.44,by=h*.52,bw=w*.48,bh=h*.34;
      ctx.fillStyle='#1A1711';ctx.fillRect(bx,by,bw,bh);
      for(let s=0;s<6;s++){const t=s/5,c=ramp(t),inset=s*bw*.07;
        ctx.fillStyle=`rgba(${c},${.25+.6*t})`;ctx.fillRect(bx+inset,by+bh-(s+1)*bh*.14,bw-inset*2,bh*.12);}
      ctx.strokeStyle='#F8CE2B';ctx.lineWidth=1.5;ctx.strokeRect(bx,by,bw,bh);
      const rad=Math.min(w*.07,h*.1);fan(w*.2,h*.84,rad);fan(w*.36,h*.84,rad);
    }
  }
  function drawAll(){drawHero();document.querySelectorAll('canvas[data-mode]').forEach(drawCard);}
  let t;window.addEventListener('resize',()=>{clearTimeout(t);t=setTimeout(drawAll,150);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',drawAll);else drawAll();
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(drawAll);
  (function(){
    if(!document.getElementById('cd'))return;
    const start=Date.UTC(2026,9,17,4,30),end=Date.UTC(2026,9,18,15,30),now=Date.now(),cd=document.getElementById('cd'),lb=document.getElementById('cdLabel');
    if(now<start){cd.textContent=Math.ceil((start-now)/86400000);}
    else if(now<=end){lb.textContent='Status';cd.textContent='Live now';}
    else{lb.textContent='Status';cd.textContent='Thanks!';}
  })();
  const form=document.getElementById('orderForm'),sel=document.getElementById('f-product'),caseField=document.getElementById('caseField');
  if(form){
  const needsCase=v=>/skin|combo|diorama/i.test(v);
  const syncCase=()=>{if(caseField)caseField.hidden=!needsCase(sel.value);};
  sel.addEventListener('change',syncCase);syncCase();
  let message='';
  form.addEventListener('submit',e=>{
    e.preventDefault();
    const d=Object.fromEntries(new FormData(form).entries()),err=document.getElementById('formErr');
    const missing=[];
    if(!d.name.trim())missing.push('your name');
    if(d.phone.replace(/\D/g,'').length<10)missing.push('a WhatsApp number with at least 10 digits');
    if(needsCase(d.product)&&!(d.case||'').trim())missing.push('your case make and model');
    if(missing.length){err.textContent='Please add '+missing.join(', ')+'.';err.hidden=false;return;}
    err.hidden=true;
    const lines=[(form.dataset.kind||'Enquiry')+': '+d.product,'Name: '+d.name.trim(),'WhatsApp: '+d.phone.trim()];
    if(needsCase(d.product))lines.push('Case: '+d.case.trim());
    if((d.city||'').trim())lines.push('City: '+d.city.trim());
    if(d.pickup)lines.push('Best time to reach me: '+d.pickup);
    if(d.link)lines.push('Product page: '+d.link);
    if((d.notes||'').trim())lines.push('Notes: '+d.notes.trim());
    message='Hi Gamers Garage, '+(form.dataset.kind==='Pre-order'?'I would like to pre-order.':'I have an enquiry.')+'\n\n'+lines.join('\n');window.__ggMsg=message;
    const s=document.getElementById('summary');s.textContent=message;s.hidden=false;
    document.getElementById('waLink').href='https://wa.me/917977186156?text='+encodeURIComponent(message);
    document.getElementById('sendRow').hidden=false;
    document.getElementById('asideTitle').textContent='Your message is ready';
    document.getElementById('asideText').textContent='Open it in WhatsApp and press Send. If WhatsApp doesn’t open, copy the message and send it to the number below.';
  });
  }
  function copy(text,btn,note){
    const done=ok=>{if(note){note.textContent=ok?'Copied.':'Select the text above and copy it.';note.hidden=false;}else{const o=btn.textContent;btn.textContent=ok?'Copied':'Select it';setTimeout(()=>btn.textContent=o,1500);}};
    try{navigator.clipboard.writeText(text).then(()=>done(true),()=>done(false));}catch(_){done(false);}
  }
  const cb=document.getElementById('copyBtn');if(cb)cb.addEventListener('click',e=>copy(window.__ggMsg||'',e.currentTarget,document.getElementById('copyNote')));
  document.querySelectorAll('[data-copy]').forEach(b=>b.addEventListener('click',()=>copy(b.dataset.copy,b)));
})();